import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {HeartIcon} from 'shells/icon/svg/heart-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import styles from '../churn/churn-page-submitted.module.css';

export function CancelPageSubmitted() {
    return (
        <div className={styles.content}>
            <Stack spacing={32} alignItems='center'>
                <HeartIcon size={80} />
                <Body useDoyle={true} size='xlarge' isBold={true} textAlign='center'>
                    We’ve received your cancellation
                </Body>
                <Body textAlign='center'>
                    We’re sorry to see you go, and wish you and your business the best.
                </Body>
                <Body textAlign='center'>
                    Our team will follow-up with an email confirmation shortly. Your Nutshell
                    account will remain accessible until the end of your billing period.
                </Body>
                {/* @ts-expect-error */}
                <Link as={RoutedLink} to='/setup/billing' variant='button-primary' size='big'>
                    Back to billing page
                </Link>
            </Stack>
        </div>
    );
}
